
document.addEventListener('DOMContentLoaded', function(){
  var money = function(el){ return el ? el.textContent.trim() : ''; };

  /* ---- variant picker ---- */
  var opts = document.querySelectorAll('.opt');
  var buyNow = document.getElementById('buyNow');
  var stickBuy = document.getElementById('stickBuy');
  var btnPrice = document.getElementById('btnPrice');
  var stickTitle = document.getElementById('stickTitle');
  var stickPrice = document.getElementById('stickPrice');

  function pick(btn){
    opts.forEach(function(o){ o.setAttribute('aria-checked', String(o === btn)); });
    if(buyNow) buyNow.href = btn.dataset.url;
    if(stickBuy) stickBuy.href = btn.dataset.url;
    if(btnPrice) btnPrice.textContent = btn.dataset.price;
    if(stickTitle) stickTitle.textContent = btn.dataset.label;
    if(stickPrice) stickPrice.textContent = btn.dataset.price;
  }
  opts.forEach(function(o){ o.addEventListener('click', function(){ pick(o); }); });
  var preset = document.querySelector('.opt[aria-checked="true"]');
  if(preset) pick(preset);

  /* ---- video ---- */
  var vid = document.getElementById('promo');
  var sBtn = document.getElementById('soundBtn');
  var playBig = document.getElementById('playBig');
  if(vid){
    var tryPlay = function(){
      var pr = vid.play();
      if(pr && pr.catch){
        pr.then(function(){ if(playBig) playBig.hidden = true; })
          .catch(function(){ if(playBig) playBig.hidden = false; });
      }
    };
    tryPlay();
    vid.addEventListener('loadeddata', tryPlay);
    vid.addEventListener('playing', function(){ if(playBig) playBig.hidden = true; });
    if(playBig) playBig.addEventListener('click', function(){
      vid.muted = false;
      if(sBtn) sBtn.lastChild.textContent = ' Sound on';
      vid.play(); playBig.hidden = true;
    });
    if(sBtn) sBtn.addEventListener('click', function(){
      vid.muted = !vid.muted;
      sBtn.lastChild.textContent = vid.muted ? ' Sound off' : ' Sound on';
      if(!vid.muted) vid.play();
    });
  }

  /* ---- mirror reveal ---- */
  var mirror = document.getElementById('mirror');
  if(mirror && 'IntersectionObserver' in window){
    new IntersectionObserver(function(es){
      es.forEach(function(e){ if(e.isIntersecting) mirror.classList.add('is-on'); });
    },{threshold:.45}).observe(mirror);
  } else if (mirror) { mirror.classList.add('is-on'); }

  /* ---- sticky buy bar ---- */
  var stick = document.getElementById('stick');
  var picker = document.querySelector('.picker');
  if(stick && picker && 'IntersectionObserver' in window){
    new IntersectionObserver(function(es){
      es.forEach(function(e){
        stick.classList.toggle('is-up', !e.isIntersecting && e.boundingClientRect.top < 0);
      });
    },{threshold:0}).observe(picker);
  }

  /* ---- mobile menu ---- */
  var burger = document.getElementById('burger');
  var mmenu = document.getElementById('mmenu');
  if(burger && mmenu){
    burger.addEventListener('click', function(){
      var on = mmenu.classList.toggle('is-on');
      burger.setAttribute('aria-expanded', String(on));
    });
    mmenu.querySelectorAll('a').forEach(function(a){
      a.addEventListener('click', function(){ mmenu.classList.remove('is-on'); });
    });
  }
});
